(() => {
  const root = document.querySelector('[data-market-suggest]');
  if (!root) return;

  const form = root.querySelector('.market-suggest__form');
  const countryInput = root.querySelector('[data-ms-country-input]');
  const closeBtn = root.querySelector('[data-ms-close]');
  const countryBtns = root.querySelectorAll('[data-ms-country]');

  const designMode = root.getAttribute('data-design-mode') === 'true';
  const delayMs = Math.max(0, Number(root.getAttribute('data-delay') || 1.5) * 1000);
  const expiryDays = Math.max(0, Number(root.getAttribute('data-expiry') || 30));
  const currentCountry = (root.getAttribute('data-current-country') || '').toUpperCase();

  const STORAGE_DISMISS = 'market-suggest-dismiss';
  const STORAGE_MANUAL = 'market-suggest-manual';

  let enabledCodes = [];
  try {
    enabledCodes = JSON.parse(root.querySelector('[data-ms-countries]')?.textContent || '[]')
      .map((c) => String(c.code || '').toUpperCase())
      .filter(Boolean);
  } catch (e) {
    enabledCodes = [];
  }

  function markManual() {
    try {
      localStorage.setItem(STORAGE_MANUAL, String(Date.now()));
    } catch (e) {}
  }

  function isManual() {
    if (designMode) return false;
    try {
      return Boolean(localStorage.getItem(STORAGE_MANUAL));
    } catch (e) {
      return false;
    }
  }

  function isDismissed() {
    if (designMode) return false;
    try {
      const raw = localStorage.getItem(STORAGE_DISMISS);
      if (!raw) return false;
      if (expiryDays <= 0) return true;
      return Date.now() - Number(raw) < expiryDays * 24 * 60 * 60 * 1000;
    } catch (e) {
      return false;
    }
  }

  function dismiss() {
    if (!designMode) {
      try {
        localStorage.setItem(STORAGE_DISMISS, String(Date.now()));
      } catch (e) {}
    }
    hide();
  }

  function show() {
    root.classList.add('is-visible');
    root.setAttribute('aria-hidden', 'false');
  }

  function hide() {
    root.classList.remove('is-visible');
    root.setAttribute('aria-hidden', 'true');
  }

  function switchTo(code) {
    if (!form || !countryInput || !code) return;
    markManual();
    countryInput.value = code;
    form.submit();
  }

  async function detectAndMaybeShow() {
    if (designMode) {
      show();
      return;
    }

    if (!currentCountry || enabledCodes.length < 2) return;
    if (isManual() || isDismissed()) return;

    let detectedCode = '';
    try {
      const rootPath = window.Shopify?.routes?.root || '/';
      const url =
        rootPath +
        'browsing_context_suggestions.json' +
        '?country[enabled]=true' +
        `&country[exclude]=${encodeURIComponent(currentCountry)}`;
      const res = await fetch(url, { credentials: 'same-origin' });
      if (!res.ok) return;
      const data = await res.json();
      detectedCode = String(data?.detected_values?.country?.handle || '').toUpperCase();
    } catch (e) {
      return;
    }

    if (!detectedCode) return;
    if (!enabledCodes.includes(detectedCode)) return;
    if (detectedCode === currentCountry) return;
    // Re-check after await: user may have picked a country while the request was in flight.
    if (isManual() || isDismissed()) return;

    show();
  }

  countryBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      switchTo(btn.getAttribute('data-ms-country') || '');
    });
  });

  closeBtn?.addEventListener('click', dismiss);

  // Header country pick uses form.submit() (no submit event) — listen for the click instead.
  document.addEventListener('click', (event) => {
    if (event.target.closest('.header-redesign__locale-option')) {
      markManual();
    }
  });

  window.setTimeout(detectAndMaybeShow, delayMs);
})();
